export default __webpack_public_path__ + "static/media/LenovoSlim.9e88259e.jpg";